import { Row, Col, Typography } from "antd";
import styles from "../../deliveryServices/DeliveryServices.module.css";

const { Paragraph } = Typography;

export default function GrubhubConnectCard({ children }) {
  return (
    <Row justify="center" align="middle" style={{ margin: "5% 20%" }}>
      <div className={styles.dsMainCardStyle}>
        <Col align="middle">
          <img
            width="50px"
            height="50px"
            src="https://bevz-media.s3.us-west-1.amazonaws.com/grubhub.png"
          />
          <Paragraph
            className={styles.dsFormTitle}
            style={{ marginBottom: "10px", marginTop: "5px" }}
          >
            Connect to Grubhub
          </Paragraph>
          {children}
        </Col>
      </div>
    </Row>
  );
};